export { isLeftRailVisibleV2, isMultiAccountScenario } from './isLeftRailVisible';
